@if (product$ | async; as product) {
  <article id="product_page" class="single-product-item">
    <div class="container">
      <div class="row product-page__row">
        <div class="product-page__gallery">
          <app-product-gallery
            [product]="product"
            [showLowestPriceTag]="isLowestPrice"
            [defaultAltText]="product | translateProductField: 'title'"
          />
        </div>

        <div class="product-page__title-wrapper">
          <h1 class="product-page__title">
            {{ product | translateProductField: 'title' }}
          </h1>
          <div class="product-page__short hidden-xs hidden-sm" [innerHTML]="product | translateProductField: 'short'"></div>
          <!-- Bazaarvoice -->
          <app-bazaarvoice
            class="product-page__reviews"
            [bvProductId]="product | extractBazaarvoiceID: 'Product'"
            [isSummary]="true"
          />
        </div>

        <div id="product_info" class="product-page__info">
          <div class="product-page__price">
            <app-product-price
              [feedId]="product.v4ApiResponse.feedID"
              [showPercentage]="false"
              [productPriceInfo]="product.price"
              [bundleRecommendedPricesProducts]="product"
              [showDiscounted]="true"
              [customFields]="product.custom_fields"
            />
          </div>
          @if (locale === 'es-ES' && lowestPrice) {
            <div class="product-page__lowest-price">
              <div class="lowest-price">
                <div class="lowest-price-wrapper">
                  <i class="fal fa-tag"></i>
                  <span i18n="@@product.lowestPriceColon">Lowest price in 30 days: </span>
                  <span [ngClass]="lowestPrice < price ? 'lowest-price-crossed' : ''">{{
                    lowestPrice | currency: currency : 'symbol' : '1.2-2'
                  }}</span>
                </div>
              </div>
            </div>
          }
          @if (productSpecificCampaign) {
            <div class="product-page__specific-campaign-highlight">
              <app-specific-campaign-highlight [productSpecificCampaign]="productSpecificCampaign" />
            </div>
          }
          @if (locale === 'fr-FR' && ecoTax !== 0) {
            <div class="product-page__ecotax">
              Dont {{ ecoTax | currency: currency : 'symbol' : '1.2-2' }}
              <button type="button" (click)="openModalEcotax()" (keypress)="openModalEcotax()">éco-Participation</button>
            </div>
          }
          @if (colorMetaproducts.length > 0) {
            <app-color-metaproduct
              [isProductPage]="true"
              [metaproducts]="colorMetaproducts"
              [productId]="product.id"
              [colorReferences]="colorReferences"
            />
          }
          @if (optionsMetaproducts.length > 0) {
            <app-options-metaproduct [isProductPage]="true" [metaproducts]="optionsMetaproducts" [feedId]="productFeeds" />
          }
          @if (product.bundleProductsV4) {
            <app-product-bundle [productBundle]="product.bundleProductsV4" [missingProductImageUrl]="missingProductImageUrl" />
          }
          <div id="buy_box">
            <app-add-to-cart
              [product]="product"
              [productTitle]="product | translateProductField: 'title'"
              [includeQuantitySelector]="false"
              (addedToCartEvent)="openAddedToCartModal($event)"
            />
          </div>

          <div class="product-page__wishlist">
            <app-add-to-wishlist
              [isInWishlist]="isInWishlist"
              (addToWishlistEvent)="addToWishlistEventHandler()"
              (removeFromWishlistEvent)="removeFromWishlistEventHandler()"
              (checkLoggedUserEvent)="checkLoggedUserEventHandler()"
            />
          </div>

          @if (isPohProduct) {
            <div class="product-page__pohalert">
              <span i18n="@@product.poh_alert"
                >Do you want to return to the page with exclusive offers from your dental professional?</span
              >
              <a [routerLink]="pohUrl">
                <span i18n="@@product.poh_alert_link">Back to exclusive offers</span> <i class="fal fa-angle-right"></i
              ></a>
            </div>
          }

          <app-product-stock-message [productStock]="product.stock.stock" />

          <app-product-benefits
            [productPriceInfo]="product.price"
            [productStock]="product.stock.stock"
            [isPohProduct]="isPohProduct"
          />
        </div>

        <div class="product-page__description">
          <div class="product-page__accordion">
            <app-product-description-accordion [product]="product" [oppenedDefault]="false" [dynamicTitles]="dynamicTitles" />
          </div>
          <div class="product-page__accordion">
            <app-product-policy-accordion [oppenedDefault]="false" />
          </div>
        </div>
      </div>

      <!-- Syndigo -->
      <app-syndigo [syndigoId]="product.id" />
      <!-- Related Products-->
      @if (relatedProducts$ | async; as relatedProducts) {
        @if (relatedProducts.length > 0) {
          <div>
            <!-- Fix when the related and may you interest shows in API results-->
            <app-product-carousel
              i18n-title="@@productRelated.relTitle"
              title="Related products"
              [productList]="relatedProducts"
            />
          </div>
        }
      }
      <!-- You may also like-->
      @if (youMayAlsoLikeProducts$ | async; as youMayAlsoLikeProducts) {
        @if (youMayAlsoLikeProducts.length > 0) {
          <div>
            <!-- Fix when the related and may you interest shows in API results-->
            <app-product-carousel
              i18n-title="@@productRelated.youTitle"
              title="You may also like"
              [productList]="youMayAlsoLikeProducts"
            />
          </div>
        }
      }
      <!-- Bazaarvoice reviews -->
      <app-bazaarvoice [bvProductId]="product | extractBazaarvoiceID: 'Product'" [isReviews]="true" />

      <div id="mobile_buy_box" class="add-to-cart__mobile">
        <h2 class="product-page__title">
          {{ product | translateProductField: 'title' }}
        </h2>
        <div class="add-to-cart__mobile-bottom">
          <app-product-price
            [feedId]="product.v4ApiResponse.feedID"
            [showPercentage]="false"
            [productPriceInfo]="product.price"
            [bundleRecommendedPricesProducts]="product"
            [showDiscounted]="false"
            [customFields]="product.custom_fields"
          />
          @if (!metaproducts?.length) {
            <app-add-to-cart
              [product]="product"
              [productTitle]="product | translateProductField: 'title'"
              [includeQuantitySelector]="false"
              (addedToCartEvent)="openAddedToCartModal($event)"
            />
          } @else {
            <button type="button" class="btn btn-primary btn-add" (click)="setShowOptions(true)">
              <span i18n="@@product.addToCart.short">Add</span>
            </button>
          }
        </div>
      </div>
      <div class="add-to-cart__mobile-options" [ngClass]="{ show: showOptions }">
        <div class="background" (click)="setShowOptions(false)"></div>
        <div class="options-content">
          <div class="options-header">
            <span i18n="@@product.chooseOption"> Click to choose an option </span>
            <button type="button" class="btn btn-icon" (click)="setShowOptions(false)">
              <span i18n="@@CLOSE" class="sr-only">Close</span>
              <i class="fal fa-times"></i>
            </button>
          </div>
          @if (colorMetaproducts.length) {
            <div class="options-color">
              <app-color-metaproduct
                [isProductPage]="true"
                [metaproducts]="colorMetaproducts"
                [productId]="product.id"
                [colorReferences]="colorReferences"
              />
            </div>
          }
          @if (optionsMetaproducts.length > 0) {
            <div class="options-options">
              <app-options-metaproduct
                [isProductPage]="true"
                [metaproducts]="optionsMetaproducts"
                [feedId]="productFeeds"
                [showOptionPrice]="true"
              />
            </div>
          }
          <app-add-to-cart
            [product]="product"
            [productTitle]="product | translateProductField: 'title'"
            [includeQuantitySelector]="false"
            (addedToCartEvent)="openAddedToCartModal($event)"
          />
        </div>
      </div>

      <div class="add-to-cart__sticky-wrapper">
        <div class="add-to-cart__sticky">
          <h2 class="product-page__title">
            {{ product | translateProductField: 'title' }}
          </h2>
          <div class="product-page__price">
            <app-product-price
              [feedId]="product.v4ApiResponse.feedID"
              [showPercentage]="false"
              [productPriceInfo]="product.price"
              [bundleRecommendedPricesProducts]="product"
              [showDiscounted]="false"
              [customFields]="product.custom_fields"
            />
          </div>
          @if (metaproducts?.length) {
            <div class="product-page__options">
              @if (colorMetaproducts.length) {
                <app-color-metaproduct
                  [isProductPage]="true"
                  [metaproducts]="colorMetaproducts"
                  [productId]="product.id"
                  [colorReferences]="colorReferences"
                  [showColorNameTitle]="false"
                  [showDropdown]="true"
                />
              }
              @if (optionsMetaproducts.length > 0) {
                <app-options-metaproduct
                  [isProductPage]="true"
                  [metaproducts]="optionsMetaproducts"
                  [feedId]="productFeeds"
                  [showDropdown]="true"
                />
              }
            </div>
          }
          <app-add-to-cart
            [product]="product"
            [productTitle]="product | translateProductField: 'title'"
            [includeQuantitySelector]="false"
            (addedToCartEvent)="openAddedToCartModal($event)"
          />
        </div>
      </div>
      <ng-container>
        <!-- Ecotax Modal -->
        <app-modal
          #ModalEcotax
          [showTitle]="false"
          [closeBackDrop]="true"
          [modalClass]="'ecotax-modal'"
          [sourceId]="'ecoTax__modal'"
        >
          <p>
            Les produits électriques et électroniques et les ampoules sont soumis à une éco-participation. Son montant est
            entièrement reversé à l'éco-organisme ESR et sert à financer le recyclage des déchets d'équipements électriques et
            électroniques (DEEE). Grâce à cette éco-participation, chacun contribue à l'amélioration de la collecte, à la
            dépollution et au recyclage des anciens produits.
          </p>
          <p>
            En savoir plus sur l'éco-organisme ESR.
            <a href="https://www.ecosystem.eco/" target="_blank" rel="noopener noreferrer">https://www.ecosystem.eco/</a>
          </p>
        </app-modal>
        <!-- Quantity Error Modal -->
        <app-modal
          #ModalErrorComponent
          i18n-title="@@product.maxQuantityErrorTitle"
          title="Quantity Error"
          [closeBackDrop]="true"
          [modalClass]="'quantity-error__modal'"
          [sourceId]="'quantityErrorModal' + uniqueModalId"
        >
          <p i18n="@@product.maxQuantityErrorTextAux">
            You have exceeded the maximum quantity of the product, a total of
            {{ MAX_ITEM_QUANTITY }} units of the product have been added.
          </p>
          <div class="quantity-error__buttons">
            <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorModal()">Close</button>
          </div>
        </app-modal>
        <!-- Cart Quantity Error Modal -->
        <app-modal
          #ModalErrorComponentCartMaxValue
          i18n-title="@@product.maxCartQuantityErrorTitle"
          title="Quantity Error"
          [closeBackDrop]="true"
          [modalClass]="'quantity-error__modal'"
          [sourceId]="'quantityErrorModalCartMaxValue' + uniqueModalId"
        >
          <p i18n="@@product.maxCartQuantityErrorTextAux">
            There are too many products in your cart, please reduce the number of products selected.
          </p>
          <div class="quantity-error__buttons">
            <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorCartMaxValueModal()">
              Close
            </button>
          </div>
        </app-modal>
        <!-- Product Added To Cart Modal -->
        <app-modal
          #ModalComponent
          i18n-title="@@product.productAddedToCart"
          title="Added to cart"
          [sourceId]="'offcanvas_added_to_cart_' + uniqueModalId"
          [modalClass]="'product-modal'"
        >
          <app-product-added-to-cart
            [product]="product"
            [productPrice]="product.price"
            [productStock]="product.stock"
            [product]="product"
            [quantity]="quantity"
            (closeModalEvent)="closeAddedToCartModal()"
          />
          <app-cross-sell-products
            [product]="product"
            (addCrossSellProductToCartEventHandler)="addCrossSellProductToCart($event)"
          />
        </app-modal>
      </ng-container>
    </div>
    <app-schema-structured-data [product]="product" />
  </article>
}
